import Skills from '@/api/skills'

export default {
  namespaced: true,
  state: {
    skills: [],
    editSkills: []
  },
  mutations: {
    setSkills (state, skills) {
      state.skills = skills
    },
    setEditSkills (state, skills) {
      state.editSkills = skills
    }
  },
  actions: {
    async getSkills ({ commit }) {
      const skills = await Skills.getSkills()
      commit('setSkills', skills || [])
    },
    async updateSkills ({ commit, state }) {
      const skills = await Skills.updateSkills(state.editSkills)
      commit('setSkills', skills || [])
    },
    loadEditSkills ({ commit, state }) {
      commit('setEditSkills', state.skills)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/skills.js